import store from '@/store';
import BADGES_COLOR_MAP from '@/data/badges-color-map';
import auth from '@/common/auth/auth';

export default function createColumns(expandData) {
    return {
        store,
        version: 4,
        defaultColumns: [
            {
                header: 'Creation Time',
                name: 'createdTime',
                type: 'datetime',
                sortable: true,
                sticky: true,
            },
            {
                name: 'status',
                sortable: true,
            },
            {
                name: 'method',
                type: 'badge',
                sortable: true,
                map: BADGES_COLOR_MAP.method,
            },
            {
                name: 'url',
                sortable: true,
            },
            {
                name: 'user.ipAddress',
                sortable: true,
            },
            {
                name: 'duration',
                sortable: true,
            },
        ],
        otherColumns: [
            {
                name: 'id',
                style: {truncate: true},
                sortable: true,
            },
            {
                name: 'route',
                sortable: true,
            },
            {
                name: 'response',
                sortable: true,
            },
            {
                name: 'request',
                sortable: true,
            },
            {
                header: 'Customer',
                name: 'relatedIds.customerId',
                type: 'link',
                sortable: false,
                to: ({fields}) => ({
                    name: 'customer-details',
                    params: {
                        id: fields.id,
                    },
                }),
                predicate: auth.$pages['customer-details'].isAllowed,
                predicateOverride: {
                    type: 'text',
                },
            },
            {
                header: 'Transaction',
                name: 'relatedIds.transactionId',
                type: 'link',
                sortable: false,
                to: ({fields}) => ({
                    name: 'transaction-details',
                    params: {
                        id: fields.id,
                    },
                }),
                predicate: auth.$pages['transaction-details'].isAllowed,
                predicateOverride: {
                    type: 'text',
                },
            },
            {
                header: 'Token',
                name: 'relatedIds.tokenId',
                sortable: true,
                style: {truncate: true},
            },
            {
                name: 'requestHeaders.User-Agent',
                sortable: true,
            },
            {
                name: 'requestHeaders.Accept',
                sortable: true,
            },
            {
                name: 'responseHeaders.Rate-Limit-Limit',
                sortable: true,
            },
            {
                name: 'responseHeaders.Rate-Limit-Remaining',
                sortable: true,
            },
            {
                name: 'responseHeaders.Rate-Limit-Reset',
                sortable: true,
            },
            {
                name: 'user.userId',
                sortable: true,
            },
            {
                name: 'user.apiKeyId',
                style: {truncate: true},
                sortable: true,
            },
            {
                name: 'user.email',
                sortable: true,
            },
            {
                name: 'user.firstName',
                sortable: true,
            },
            {
                name: 'user.lastName',
                sortable: true,
            },
            {
                name: 'user.userAgent',
                sortable: true,
            },
            {
                name: 'user.fingerprint',
                sortable: true,
            },
            {
                name: 'user.isSupport',
                sortable: true,
            },
        ],
        lockedColumns: [
            {
                header: false,
                type: 'button',
                style: {
                    tooltip: 'Expand Data',
                    icon: 'eye',
                },
                click: ({rowData}) => {
                    expandData(rowData);
                },
            },
        ],
    };
}
